import React, { useEffect, useRef } from "react";
import Slider from "react-slick";

export default function Carousel (props) {
  let sliderRef = useRef(null);

  useEffect(() => {
    sliderRef.slickGoTo(props.settings.initialSlide, props.dontAnimate);
  });

  return (
    <Slider
      ref={slider => {
        sliderRef = slider;
      }}
      {...props.settings}
      nextArrow={<NextArrow />}
      prevArrow={<PrevArrow />}
    >
      {props.displayArray}
    </Slider>
  );
};

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className={'custom-slick-next'}
      onClick={onClick}
    >
      <div className="bf-arrow-right next-arrow"></div>
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className={'custom-slick-prev'}
      onClick={onClick}
    >
      <div className="bf-arrow-left prev-arrow"></div>
    </div>
  );
};